import { cn } from "@/lib/utils";
import tests from "./data/tests";
import { TestCard } from "./TestCard";

export const TestList = ({ className, card, user }) => {
  return (
    <div className={cn("flex flex-col gap-4 w-full items-center", className)}>
      {tests.map((test) => (
        <TestCard
          title={test.name}
          description={test.description}
          link={test.link}
          key={test.id}
          type={test.type}
          card={card}
          user={user}
        />
      ))}
    </div>
  );
};
